import {
  getApiV1ThreeLetterCodePartnerAdminsTopBanners,
  getGetApiV1ThreeLetterCodePartnerAdminsTopBannersKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  GetApiV1ThreeLetterCodePartnerAdminsTopBanners200,
  GetApiV1ThreeLetterCodePartnerAdminsTopBannersParams,
} from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
  /** 1ページあたりの取得件数（省略時は API 既定の 25 件。API 上限は 100） */
  limit?: number;
};

type ReturnType = {
  /** トップバナー一覧データ */
  data: GetApiV1ThreeLetterCodePartnerAdminsTopBanners200;
};

/**
 * useGetPartnerAdminsTopBannersフックの型定義
 */
type IUseGetPartnerAdminsTopBanners = (args: Args) => ReturnType;

/**
 * パートナー管理者用トップバナー一覧取得フック
 * Suspenseを使用してデータを取得
 *
 * @param args.threeLetterCode - 3文字コード
 * @param args.limit - 1ページあたりの取得件数（省略時は API 既定の 25 件）
 */
export const useGetPartnerAdminsTopBanners: IUseGetPartnerAdminsTopBanners = ({
  threeLetterCode,
  limit,
}) => {
  const apiParams: GetApiV1ThreeLetterCodePartnerAdminsTopBannersParams = {
    ...(limit && { limit }),
  };

  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsTopBannersKey(threeLetterCode, apiParams),
    () => getApiV1ThreeLetterCodePartnerAdminsTopBanners(threeLetterCode, apiParams),
    { suspense: true }
  );

  return {
    data,
  };
};
